/**
 * @file Controle da execução em jogo.
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React, { Suspense } from "react";

// Importação de componentes
import ViewLogar from "./ViewComponents/View_Logar";

import ViewInicial from "./ViewComponents/View_Inicial";
import ViewCredito from "./ViewComponents/View_Credito";
import ViewCompartilhar from "./ViewComponents/View_Compartilhar";
import Vitoria from "./ViewComponentsJogo/SubViewComponentsJogo/vitoria";
import ViewInstrucao from "./ViewComponents/View_Instrucao";
import ViewModos from "./ViewComponents/View_Modos";
// import ViewJogo from "./ViewJogo";
import View from "./View";
import View2 from "./View2";
import View1 from "./View1";
import Nav from "./Nav";

// Conteudo ilustrado das intruções
import nav1 from "../Assets/instrucoes/navegacao1_recorte.webp";
import nav2 from "../Assets/instrucoes/navegacao2_recorte.webp";

import acao1 from "../Assets/instrucoes/Acao1_recorte.webp";

import obj1 from "../Assets/instrucoes/objetivo1_recorte.webp";

import lis1 from "../Assets/instrucoes/destaque1_recorte.webp";
import lis2 from "../Assets/instrucoes/destaque2_recorte.webp";
import mob1 from "../Assets/instrucoes/destaque2Mobile_recorte.webp";

//fase assets
import arbusto1 from "../Assets/fases/arbusto1.webp"
import arbusto2 from "../Assets/fases/arbusto2.webp"
import arbusto3 from "../Assets/fases/arbusto3.webp"

// Componentes de roteamento
import { BrowserRouter, Router, Routes, Route, Link, Navigate } from "react-router-dom";

// Componentes Front-end
import "../Style/Diretrizes.scss";

// Controladores
import ControleJogo from "./Controllers/ControleJogo";
import ControleRank from "./Controllers/Requests/ControleRank";

// Request Controladores
import firebase from "./Controllers/Requests/Config";
import AuthFirebase from "./Controllers/Requests/Auth"
const auth = new AuthFirebase()
const serve = new ControleRank(firebase, auth)

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

//  const JogoInstance = React.lazy(() => import('./Controllers/ControleJogo'));
const ViewJogo = React.lazy(() => import("./ViewJogo"));
const JogoInstance = new ControleJogo();

export default function App() {
  // ROTEAMENTO - colocar controle de estados da aplicação
  return (
    <BrowserRouter basename="/app/cruzadinhas/jardim-medicinal/">
      <Routes>
        <Route
          path="*"
          element={
            <main style={{ padding: "1rem" }}>
              <Navigate to="/" replace />
            </main>
          }
        />
        <Route exact path="/login" element={<Telalogin />} />
        <Route exact path="/" element={
          <RequireAuth>
            <Telainicial />
          </RequireAuth >}
        />
        <Route exact path="/creditos" element={<TelaCreditos />}/>
        <Route exact path="/compartilhar" element={<TelaCompartilhar />}/>
        <Route exact path="/instrucao-0" element={
          <RequireAuth>
            <TelaInstrucao0 />
          </RequireAuth >}
        />
        <Route exact path="/instrucao-1" element={
          <RequireAuth>
            <TelaInstrucao1 />
          </RequireAuth >}
        />
        <Route exact path="/instrucao-2" element={
          <RequireAuth>
            <TelaInstrucao2 />
          </RequireAuth >}
        />
        <Route exact path="/instrucao-3" element={
          <RequireAuth>
            <TelaInstrucao3 />
          </RequireAuth >}
        />
        <Route exact path="/preparado" element={
          <RequireAuth>
            <TelaPreparado />
          </RequireAuth >}
        />
        <Route exact path="/modo" element={
          <RequireAuth>
            <TelaModos />
          </RequireAuth >}
        />
        <Route exact path="/modo/fase" element={
          <RequireAuth>
            <TelaFase />
          </RequireAuth >}
        />
        <Route exact path="/vitoria" element={
          <RequireAuth>
            <Telavitoria />
          </RequireAuth >}
        />
        <Route exact path="/jogo" element={
          <RequireAuth>
            <Jogo />
          </RequireAuth >}
        />
      </Routes>
    </BrowserRouter>
  );

  function RequireAuth({ children, ...rest }) {
    console.log("TESTE LOGIN: ", auth.verifyUser());
    if (!auth.verifyUser())
      return (
        <Navigate to="/login" replace />
      );
    else
      return children
  }

  function Telavitoria() {
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <Vitoria ControleJogo={JogoInstance} Serve={serve} />
      </div>
    );
  }

  function Telalogin() {
    return (
      <div>
        <View conteudo={<ViewLogar serve={serve} auth={auth} />} />

      </div>
    );
  }

  function Telainicial() {
    return (
      <div>
        <View1 conteudo={<ViewInicial serve={serve} auth={auth} />} />
      </div>
    );
  }
  function TelaCreditos() {
    return (
      <div>
        <View1 conteudo={<ViewCredito back={true} />} />
      </div>
    );
  }

  function TelaCompartilhar() {
    return (
      <div>
        <View1 conteudo={<ViewCompartilhar back={true} />} />
      </div>
    );
  }

  function TelaInstrucao0() {
    const instrucao = (
      <div className="d-flex flex-column w-100 h-100">
        <div className="flex-grow-1 d-flex  flex-row justify-content-center align-items-center pt-3">
          <div className="flex-fill text-center">
            <img 
            className="img-col1 img-fluid" 
            src={obj1} 
            alt="nevegue clicando nas palavras do tabuleiro" 
            />
            </div>
        </div>
        <div className="flex-fill d-flex justify-content-center align-items-end fs-bold ">
          <p>
            Você precisa usar os contextos para encontrar as palavras, quando 
            precisar de ajuda extra clique em dica!
          </p>
        </div>
      </div>
    );

    const elemento = ViewInstrucao(instrucao);
    const prev = "/";
    const next = "/instrucao-1";
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <View2
          className="flex-pill"
          conteudo={elemento}
          prev={prev}
          next={next}
          titulo={"Objetivo"}
        />
      </div>
    );
  }

  function TelaInstrucao1() {
    const instrucao = (
      <div className="d-flex flex-column w-100 h-100">
        <div className="flex-grow-1 d-flex  flex-row align-items-center pt-3">
          <div className="flex-fill">
            <img
              className="img-col2 img-fluid"
              src={nav1}
              alt="nevegue clicando nas palavras do tabuleiro"
            />
          </div>
          <div className="flex-fill">
            <img
              className="img-col2 img-fluid"
              src={nav2}
              alt="nevegue clicando nas setas do teclado"
            />
          </div>
        </div>
        <div className="flex-fill d-flex justify-content-center align-items-end fs-bold ">
          <p>
            Neste jogo você pode navegar entre as palavras clicando nas palavras
            no tabuleiro ou através das setas do teclado virtual!
          </p>
        </div>
      </div>
    );

    const elemento = ViewInstrucao(instrucao);
    const prev = "/instrucao-0";
    const next = "/instrucao-2";
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <View2
          className="flex-pill"
          conteudo={elemento}
          prev={prev}
          next={next}
          titulo={"Navegação"}
        />
      </div>
    );
  }
  function TelaInstrucao2() {
    const instrucao = (
      <div className="d-flex flex-column w-100 h-100 ">
        <div className="flex-grow-1 d-flex  flex-row justify-content-center align-items-center pt-3">
          <div className="flex-fill text-center">
            <img
              className="img-col1 img-fluid"
              src={acao1}
              alt="nevegue clicando nas palavras do tabuleiro"
            />
          </div>
        </div>
        <div className="flex-fill d-flex justify-content-center align-items-end fs-bold ">
          <p>
            Em todas as plataformas você deve fazer uso do teclado virtual para
            preencher as lacunas!
          </p>
        </div>
      </div>
    );

    const elemento = ViewInstrucao(instrucao);
    const prev = "/instrucao-1";
    const next = "/instrucao-3";
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <View2
          conteudo={elemento}
          prev={prev}
          next={next}
          titulo={"Preencher"}
        />
      </div>
    );
  }

  function TelaInstrucao3() {
    let instrucao;
    if (window.screen.width < 768) {
      instrucao = (
        <div className="d-flex flex-column w-100 h-100">
          <div className="flex-grow-1 d-flex  flex-row justify-content-center align-items-center pt-3">
            <div className="flex-fill text-center">
              <img
                className="img-col2 img-fluid"
                src={lis1}
                alt="nevegue clicando nas palavras do tabuleiro"
              />
            </div>

            <div className="flex-fill text-center">
              <img
                className="img-col2 img-fluid"
                src={mob1}
                alt="nevegue clicando nas palavras do tabuleiro"
              />
            </div>
          </div>
          <div className="flex-fill d-flex justify-content-center align-items-end fs-bold ">
            <p>
              Você pode revisar as palavras através da <i>lista de palavras</i>{" "}
              clicando no canto superior direito da tela, e quando uma palavra
              estiver certa será demarcada em verde!
            </p>
          </div>
        </div>
      );
    } else {
      instrucao = (
        <div className="d-flex flex-column w-100 h-100">
          <div className="flex-grow-1 d-flex  flex-row justify-content-center align-items-center pt-3">
            <div className="flex-fill text-center">
              <img
                className="img-col2 img-fluid"
                src={lis1}
                alt="nevegue clicando nas palavras do tabuleiro"
              />
            </div>

            <div className="flex-fill text-center">
              <img
                className="img-col2 img-fluid"
                src={lis2}
                alt="nevegue clicando nas palavras do tabuleiro"
              />
            </div>
          </div>
          <div className="flex-fill d-flex justify-content-center align-items-end fs-bold ">
            <p>
              Você pode revisar as palavras através da <i>lista de palavras</i>,
              e quando uma palavra estiver certa será demarcada em verde!
            </p>
          </div>
        </div>
      );
    }

    const elemento = ViewInstrucao(instrucao);
    const prev = "/instrucao-2";
    const next = "/preparado";
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <View2 conteudo={elemento} prev={prev} next={next} titulo={"Revisão"} />
      </div>
    );
  }

  function TelaPreparado() {
    const instrucao = "Preparado? Então vamos começar!";
    const acoes = (
      <div>
        <Link to="/modo">
          <button
            type="button"
            className="button-custom inicial bg-white arround-6"
          >
            <span className="material-icons-outlined md-44 align-middle pe-3">
              sports_esports
            </span>
            JOGAR
          </button>
        </Link>
      </div>
    );
    const elemento = ViewModos(instrucao, acoes);
    const prev = "/instrucao-3";
    const next = null;
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <View2
          conteudo={elemento}
          prev={prev}
          next={next}
          titulo={"Instruções"}
        />
      </div>
    );
  }

  function fase(val) {
    JogoInstance.manageLevel(val);
    JogoInstance.init();
  }

  function TelaFase() {
    const faseInd = [1, 2, 3];
    const arbustos = [arbusto1, arbusto2, arbusto3];
    const instrucao = null;
    let fases = [];
    for (let index = 0; index < faseInd.length; index++) {
      const checkNivel = disableNivel(faseInd[index])
      const element = (
        <div
          key={index}
          className="flex-fill w-100 text-center  d-flex justify-content-center align-items-center"
        >
          <span className="position-relative-container">
            <img alt="EIC" className="arbusto top-10" src={arbustos[index]} />
          </span>
          <Link to={checkNivel ? '/jogo' : './'}>
            <button
              type="button"
              onClick={() => checkNivel ? fase(faseInd[index]) : null}
              className={checkNivel ? "button-custom-fase fase bg-white arround-6 flex-column" : "button-custom-fase fase bg-white arround-6 flex-column disabled"}
            >
              <div>
                <span className="float-end align-middle w-100">
                  {faseInd[index]}
                </span>
                <div>
                  <div className="material-icons-outlined md-36 align-middle float-start  fase-1">
                    {progresso(auth.usuario.progresso[JogoInstance.modo][faseInd[index]], 1)}
                  </div>
                  <div className="material-icons-outlined md-40 align-middle float-center fase-2">
                    {progresso(auth.usuario.progresso[JogoInstance.modo][faseInd[index]], 2)}
                  </div>
                  <div className="material-icons-outlined md-36 align-middle float-end fase-3">
                    {progresso(auth.usuario.progresso[JogoInstance.modo][faseInd[index]], 3)}
                  </div>
                </div>
              </div>


            </button>
          </Link>
        </div>
      );
      fases.push(element);
    }
    const acoes = React.createElement(
      "div",
      { id: "fases", className: "d-flex w-100 h-100 flex-column" },
      fases
    );

    const elemento = ViewModos(instrucao, acoes);
    const prev = null;
    const next = null;
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <View2
          conteudo={elemento}
          prev={prev}
          next={next}
          titulo={"Escolha o Nível"}
        />
      </div>
    );
  }





  function disableNivel(fase) {
    if (fase === 1)
      return "button-custom-fase fase bg-white arround-6 flex-column"
    if (auth.usuario.progresso[JogoInstance.modo][fase - 1] === 0)
      return "button-custom-fase fase bg-white arround-6 flex-column disabled"
    else
      return "button-custom-fase fase bg-white arround-6 flex-column"
  }

  function disableNivelLink(fase) {
    if (fase === 1)
      return '/jogo'
    if (auth.usuario.progresso[JogoInstance.modo][fase - 1] === 0)
      return null
    else
      return '/jogo'
  }


  function disableNivel(fase) {
    if (fase === 1)
      return true
    if (auth.usuario.progresso[JogoInstance.modo][fase - 1] === 0)
      return false
    else
      return true
  }

  function progresso(ponto, fase) {
    if (ponto >= fase)
      return "star"
    else
      return "star_outline"
  }
  
  function modo(val) {
    JogoInstance.manageModel(val);
  }

  function TelaModos() {
    const instrucao = null;
    const acoes = (
      <div className="d-flex h-75 flex-column">
        <div className="flex-fill w-100 text-center  d-flex justify-content-center align-items-center">
          <Link to="/modo/fase">
            <button
              type="button"
              onClick={() => modo(1)}
              className="button-custom modo bg-white arround-6"
            >
              <span className="float-center align-middle">CURIOSIDADES</span>
            </button>
          </Link>
        </div>
        <div className="flex-fill w-100 text-center  d-flex justify-content-center align-items-center">
          <Link to="/modo/fase">
            <button
              type="button"
              onClick={() => modo(2)}
              className="button-custom modo bg-white arround-6"
            >
              <span className="float-center align-middle">USO DA PLANTA</span>
            </button>
          </Link>
        </div>
        <div className="flex-fill w-100 text-center  d-flex justify-content-center align-items-center">
          <Link to="/modo/fase">
            <button
              type="button"
              onClick={() => modo(3)}
              className="button-custom modo bg-white arround-6"
            >
              <span className="float-center align-middle">NOME POPULAR</span>
            </button>
          </Link>
        </div>
      </div>
    );
    const elemento = ViewModos(instrucao, acoes);
    const prev = null;
    const next = null;
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <View2
          conteudo={elemento}
          prev={prev}
          next={next}
          titulo={"Escolha o tema"}
        />
      </div>
    );
  }

  function Jogo() {
    return (
      <div className="d-flex flex-row">
        <Nav auth={auth} className="flex-pill" />
        <Suspense
          fallback={
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          }
        >
          <ViewJogo Jogo={JogoInstance} Serve={serve} />
        </Suspense>
      </div>
    );
  }
}
